import { alertEventBus } from 'src/core/events/Events';
import type { AlertRequestEvent } from 'src/core/events/Events';
import Constants from 'src/core/utils/Constants';
import type { ShowAlertProps } from 'src/core/utils/types/ShowAlertTypes';

/**
 * Web sibling of showAlert. react-native-web ships Alert as `static alert() {}`, so on web the
 * button never appeared and the action behind it never ran: deleting an account left the visitor
 * on a settings screen with no confirmation and no way home, and a refused camera never sent
 * anyone back. The request goes to AlertDialog instead, which lives in the React tree and
 * therefore works standalone as well as inside the cross-origin iframe on topicusevents.nl/app.
 *
 * It travels as an event for the same reason errorHandler's does: this file is core, and core
 * cannot import the domain store that holds the queue. `cancelable` is dropped on purpose -- it is
 * an Android dismissal rule with no counterpart in the dialog.
 */
export default function showAlert({
	title,
	message = null,
	confirmText,
	cancelText,
	confirmButtonStyle,
	onConfirm,
	onCancel,
	buttons,
}: ShowAlertProps): void {
	const event: AlertRequestEvent = {
		title,
		message,
		kind: cancelText === undefined ? 'notice' : 'confirm',
		confirmText,
		cancelText,
		isDestructive: confirmButtonStyle === 'destructive',
		onConfirm,
		onCancel,
		buttons: buttons?.map((button) => ({
			text: button.text,
			isCancel: button.style === 'cancel',
			isDestructive: button.style === 'destructive',
			onPress: button.onPress,
		})),
	};

	alertEventBus.emit(Constants.eventAlertOnRequest, event);
}
